import { Component, inject, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { ConditionOperator } from '@devices/models';

import { IncidentRuleOperatorComponent } from '../incident-rule-operator';

@Component({
  imports: [MatSelectModule, MatIconModule, ReactiveFormsModule, MatFormFieldModule, FormsModule, IncidentRuleOperatorComponent],
  selector: 'avs-operator',
  templateUrl: './operator.component.html',
})
export class OperatorComponent implements ControlValueAccessor {
  ngControl = inject(NgControl, { self: true });
  readonly errorMatcher: ErrorStateMatcher = {
    isErrorState: () => {
      return !!(this.ngControl?.control?.invalid && (this.ngControl?.control?.touched || this.ngControl?.control?.dirty));
    },
  };
  protected operators = Object.values(ConditionOperator);
  protected value = signal<ConditionOperator | null>(null);
  protected isDisabled = signal(false);

  constructor() {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  onChange = (_: any) => {
  };
  onTouched = () => {
  };

  onValueChange(newValue: ConditionOperator) {
    this.value.set(newValue);
    this.onChange(newValue);
  }

  // Методи інтерфейсу ControlValueAccessor
  writeValue(val: ConditionOperator) {
    this.value.set(val);
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.isDisabled.set(isDisabled);
  }
}
